/**
 * @generated SignedSource<<799fce35647bb58a0f3253f11a7ffbc6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SplitDetailsContent_address$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useSplit_address">;
  readonly " $fragmentType": "SplitDetailsContent_address";
};
export type SplitDetailsContent_address$key = {
  readonly " $data"?: SplitDetailsContent_address$data;
  readonly " $fragmentSpreads": FragmentRefs<"SplitDetailsContent_address">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SplitDetailsContent_address",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSplit_address"
    }
  ],
  "type": "EthereumAddressType",
  "abstractKey": null
};

(node as any).hash = "c2fc84b0be4d304f904d62cd627feefd";

export default node;
